import React from "react";

class AdvancedAvatar extends React.Component {
  render() {
    const { children, className } = this.props;

    return (
      <>
        <div className={`advanced-avatar ${className}`}>{children}</div>
      </>
    );
  }
}

export default AdvancedAvatar;
